module.exports = __webpack_public_path__ + "wap/static/img/404.7911357.png";